import React from 'react';
import { Activity } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';

const SystemStatus: React.FC = () => {
  const { language, isDarkOps } = useTheme();
  const slotsRemaining = 2; // This could be dynamic in the future

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-[50] ${isDarkOps ? 'bg-black/90 border-b border-terminal-green/30' : 'bg-clinical/95 border-b border-zinc-300'} backdrop-blur-md`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2 flex items-center justify-center gap-3">
        <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
        <span className={`font-mono text-xs ${isDarkOps ? 'text-terminal-green' : 'text-black'}`}>
          {language === 'en' ? 'SYSTEMS: NOMINAL' : 'SISTEMAS: NOMINAL'}
        </span>
        <span className={`font-mono text-xs ${isDarkOps ? 'text-zinc-500' : 'text-zinc-400'}`}>//</span>
        <span className={`font-mono text-xs ${isDarkOps ? 'text-cyber-yellow' : 'text-red-500'}`}>
          {language === 'en' 
            ? `Q1 DEPLOYMENT SLOTS: ${slotsRemaining} REMAINING`
            : `ESPACIOS Q1: ${slotsRemaining} RESTANTES`
          }
        </span>
      </div>
    </motion.div>
  );
};

export default SystemStatus;
